module.exports = __webpack_public_path__ + "img/graph-sm.c6e92c4f.png";